import React from 'react';
import { SkeletonBox } from '@leagueplatform/web-common-components';
import { useTheme } from '@leagueplatform/genesis-commons';
import { ENABLE_NEW_JOURNEY_EXPERIENCE } from '@leagueplatform/health-journey-common';

import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { Box, HeadingText } from '@leagueplatform/genesis-core';
import { ActivityContainer } from '../activity-container/activity-container.component';
import { useHealthProgramCategories } from '../../hooks/use-health-program-categories.hook';

import CategoryCard from './category-card.component';

export const HealthProgramCategories = () => {
  const { data: isNewJourneyExperienceEnabled } = useFeatureFlagQuery(
    ENABLE_NEW_JOURNEY_EXPERIENCE,
  );
  const { data, isLoading } = useHealthProgramCategories();

  const theme = useTheme();

  if (isLoading)
    return (
      <SkeletonBox
        height="200px"
        width="100%"
        marginBottom={theme.space.twoAndHalf}
      />
    );

  return (
    data?.categories && (
      <Box css={{ paddingBottom: '$four' }}>
        <HeadingText
          level="2"
          size="xl"
          css={{ marginBottom: '$four' }}
          as={isNewJourneyExperienceEnabled ? 'h3' : 'h2'}
        >
          {data?.title}
        </HeadingText>
        <ActivityContainer as="ul">
          {data?.categories?.map(({ name, icon_url: iconUrl, id }: any) => (
            <CategoryCard
              key={id}
              categoryId={id}
              name={name}
              iconUrl={iconUrl}
            />
          ))}
        </ActivityContainer>
      </Box>
    )
  );
};
